// extracted by mini-css-extract-plugin
export default {"description":"vVx4RDH36VDwO5MiS5_Q-style-description","cards":"gVP7YkzbSrii2y5Zvf4K-style-cards"};